import React from 'react';

import { ProfileHeaderCard } from './components/ProfileHeaderCard.component';
import { ProfileEditForm } from './components/ProfileEditForm.component';
import styles from './Profile.module.scss';

export const ProfileComponent = () => (
  <div className={styles.profilePage}>
    <ProfileHeaderCard />
    <ProfileEditForm />
  </div>
);

ProfileComponent.displayName = 'Profile';
